/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Sign_Up_TitleInputs */

const en_seo_sign_up_title = /** @type {(inputs: Seo_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account`)
};

const pl_seo_sign_up_title = /** @type {(inputs: Seo_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Załóż konto`)
};

/**
* | output |
* | --- |
* | "Create an account" |
*
* @param {Seo_Sign_Up_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_sign_up_title = /** @type {((inputs?: Seo_Sign_Up_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Sign_Up_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_sign_up_title(inputs)
	return en_seo_sign_up_title(inputs)
});